import React, { useEffect, useState } from 'react';
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
interface CountdownTimerProps {
  className?: string;
  boxClassName?: string;
  textClassName?: string;
  labelClassName?: string;
}
export function CountdownTimer({
  className = 'flex gap-4 justify-center',
  boxClassName = 'bg-brand-dark border border-brand-border rounded-xl p-4 min-w-[90px] flex flex-col items-center',
  textClassName = 'text-5xl font-heading font-bold text-brand-accent',
  labelClassName = 'text-xs uppercase tracking-widest text-white/50 mt-2 font-badge font-bold'
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 23,
    minutes: 58,
    seconds: 33
  });
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
    const savedEndTime = localStorage.getItem('megapack_countdown_end');
    let endTime: number;
    if (savedEndTime) {
      endTime = parseInt(savedEndTime, 10);
      if (endTime < Date.now()) {
        endTime = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('megapack_countdown_end', endTime.toString());
      }
    } else {
      endTime = Date.now() + 23 * 60 * 60 * 1000 + 58 * 60 * 1000 + 33 * 1000;
      localStorage.setItem('megapack_countdown_end', endTime.toString());
    }
    const calculateTimeLeft = () => {
      const difference = endTime - Date.now();
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      } else {
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  if (!mounted) return null;
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className={className} data-id="element-65">
      <div className={boxClassName} data-id="element-66">
        <span className={textClassName} data-id="element-67">{formatNumber(timeLeft.hours)}</span>
        <span className={labelClassName} data-id="element-68">hs</span>
      </div>
      <div className="text-5xl font-bold text-white/30 self-start mt-3" data-id="element-69">:</div>
      <div className={boxClassName} data-id="element-70">
        <span className={textClassName} data-id="element-71">{formatNumber(timeLeft.minutes)}</span>
        <span className={labelClassName} data-id="element-72">min</span>
      </div>
      <div className="text-5xl font-bold text-white/30 self-start mt-3" data-id="element-73">:</div>
      <div className={boxClassName} data-id="element-74">
        <span className={textClassName} data-id="element-75">{formatNumber(timeLeft.seconds)}</span>
        <span className={labelClassName} data-id="element-76">seg</span>
      </div>
    </div>;
}